import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import InputMask from '@mona-health/react-input-mask';
import { Input } from '../../Input';
import classNames from 'classnames';
import { useToggle } from 'react-use';
import { Icon } from '../../Icon';
const AMEX_CARD_PAN = ['34', '37'];
export const CvcInput = ({ control, name, cardNumber, size, disabled, dataTestId, className, inputClassName, onFocus, onBlur }) => {
    const [isFocused, toggleIsFocused] = useToggle(false);
    const validCvcLength = AMEX_CARD_PAN.includes(cardNumber?.trim().substring(0, 2)) ? 4 : 3;
    const cvcMaskFormat = Array(validCvcLength).fill('9').join('');
    const { field, formState } = useController({
        name: name,
        control,
        rules: {
            required: {
                value: true,
                message: 'CVC is required'
            },
            validate: (v) => (v && v.trim().length === validCvcLength) || 'Invalid CVC'
        }
    });
    const hasErrors = formState.errors[field.name];
    const isSuccess = field.value && !hasErrors;
    const iconClassName = classNames('absolute z-50 inset-y-0 my-auto pointer-events-none', !isFocused && (hasErrors || isSuccess) ? 'right-10' : 'right-3');
    const handleOnBlur = (event) => {
        field.onBlur();
        onBlur?.(event);
        toggleIsFocused(false);
    };
    const handleOnFocus = (event) => {
        onFocus?.(event);
        toggleIsFocused(true);
    };
    return (_jsx(InputMask, { mask: cvcMaskFormat, ...field, disabled: disabled, maskPlaceholder: null, ref: null, type: "tel", onBlur: handleOnBlur, onFocus: handleOnFocus, children: _jsx(Input, { autoComplete: name, className: className, dataTestId: dataTestId, disabled: disabled, errors: hasErrors, inputClassName: inputClassName, isSuccess: isSuccess, placeholder: "CVC", prePostIcon: _jsx(Icon, { className: iconClassName, name: "cvc" }), ref: field.ref, size: size, type: "tel" }) }));
};
